<div class="q-stats-column">
  <div class="q-stats">
    <div class="q-header">Q2</div>
    <app-stats *ngIf="q2Data" [values]="q2Data"></app-stats>
  </div>
  <div class="q-stats">
    <div class="q-header">Q3</div>
    <app-stats *ngIf="q3Data" [values]="q3Data"></app-stats>
  </div>
</div>
<div class="dash-line"></div>
<div class="q-stats">
  <div class="q-header">Q4</div>
  <app-stats *ngIf="q4Data" [values]="q4Data"></app-stats>
</div>